import { makeStyles } from "@material-ui/styles";

export const drawerWidth = 300;
export default makeStyles((theme) => ({
    chipRoot:{
        padding:0,
        height:15
    }
}));
